import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function paginaActualReducer(state= initialState.paginaActual, action){
	
	switch(action.type){
		case types.SET_PAGINA_ACTUAL:	            
			return action.datos;
		//break;		
	
		default:
			return state;
	}
}